import styled from 'styled-components';
import { deviceMax } from '../../../styles/MediaQuery';
import { darkGreen, lightGray, matterhornText } from '../../../styles/Variables';

export const Person = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: 1fr 1fr 1fr;
    border-top: 1px solid ${lightGray};
    border-bottom: 1px solid ${lightGray};
    margin-bottom: 60px;

    @media ${deviceMax.tablet} {
        grid-template-columns: 1fr;
        width: calc(100% - 1rem);
        border-top: none;
    }
`;

export const PersonColumnBoxWithImage = styled.div`
    display: flex;
    justify-content: flex-start;

    img {
        width: 140px;
        height: 80px;
        object-fit: cover;

        @media ${deviceMax.tablet} {
            width: 100%;
            height: 100%;
            max-height: 300px;
        }
    }

    @media ${deviceMax.tablet} {
        flex-direction: column;
    }
`;

export const PersonColumnBox = styled.div`
    padding-bottom: 12px;

    * {
        font-family: Arial, Helvetica;
        font-weight: 400;
        font-size: 0.875rem;
        margin: 0;
        padding: 0;
    }
`;

export const PersonTextField = styled.div`
    margin: 12px 0 0 0;
    padding: 0 0 0 20px;
    word-break: break-word;

    a {
        color: ${darkGreen};
        text-decoration: none;
    }

    @media ${deviceMax.tablet} {
        padding: 0;
    }
`;

interface isPictureInterface {
    readonly isPicture?: boolean;
}

export const PersonName = styled.div<isPictureInterface>`
    font-family: Arial, Helvetica;
    font-size: 0.875rem;
    color: ${matterhornText};
    font-weight: 700;
    ${(props) =>
        props.isPicture &&
        ` padding: 0 0 0 20px;
    margin: 12px 0 0 0;`}

    @media ${deviceMax.tablet} {
        padding: 0;
    }
`;
